import { useHookstate } from "@hookstate/core";
import {
  UPDATED_CAR_DATA_STATE,
  MAP_GLOBAL_STATES,
  GLOBAL_SITE_SEARCH,
} from "globalStore/globalStore";
import { useEffect, useState } from "react";
import { isCarInUse } from "../_helperFunctions/isCarInUse";
import { carType } from "../_helperFunctions/carType";
import { carConnectionType } from "_helperFunctions/connectionType";
import {
  batteryStatusAlert,
  paceStatusAlert,
} from "_helperFunctions/paceAndBatteryStatus";

export const useFilteredCarsHook = ({
  marshalCars,
  specialCars,
  memberCars,
  bewrageCars,
  fleetCars,
  notCommunicatingCars,
  notInUseCars,
  paceWarning,
  paceCritical,
  batteryWarning,
  batteryCritical,
  CarLocationBtn = false,
}) => {
  const { updatedCarData: updatedCarDataState } = useHookstate(
    UPDATED_CAR_DATA_STATE
  );
  const { isFirstUpdate } = useHookstate(GLOBAL_SITE_SEARCH);
  const { getSelectedCarsState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    if (!isFirstUpdate.get()) {
      if (
        marshalCars &&
        specialCars &&
        memberCars &&
        bewrageCars &&
        fleetCars &&
        notCommunicatingCars &&
        notInUseCars
      ) {
        if (
          updatedCarDataState.get() &&
          updatedCarDataState.get().length !== 0
        ) {
          let allCars = JSON.parse(
            updatedCarDataState.get() && updatedCarDataState.get()
          );
          let tempArray = [];
          let batteryAndPace = [];
          if (allCars && allCars?.length !== 0) {
            for (let i = 0; i < allCars.length; i++) {
              let carTypeHasExplicitFilter =
                allCars[i]?.Car?.CarType === carType?.marshal ||
                allCars[i]?.Car?.CarType === carType?.handicap ||
                allCars[i]?.Car?.CarType === carType?.member ||
                allCars[i]?.Car?.CarType === carType?.bevcart ||
                allCars[i]?.Car?.CarType === carType?.member;
              if (notCommunicatingCars) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notCommunicatingCars &&
                    allCars[i]?.Car?.Connection ===
                      carConnectionType?.notCommunicatingCarEnabled) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                ) {
                  tempArray.push(allCars[i]);
                }
              } else if (
                !notCommunicatingCars &&
                allCars[i]?.Car?.Connection !==
                  carConnectionType?.notCommunicatingCarEnabled
              ) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                ) {
                  tempArray.push(allCars[i]);
                }
              }
            }

            if (tempArray && tempArray.length !== 0) {
              for (var i = 0; i < tempArray.length; i++) {
                if (
                  paceWarning ||
                  paceCritical ||
                  batteryWarning ||
                  batteryCritical
                ) {
                  if (
                    (paceWarning &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusWarning) ||
                    (paceCritical &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusCritical) ||
                    (batteryWarning &&
                      tempArray[i]?.Car?.BatteryLevel >
                        batteryStatusAlert?.criticalBatteryLevel &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.warningBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging) ||
                    (batteryCritical &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.criticalBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging)
                  ) {
                    batteryAndPace.push(tempArray[i]);
                  }
                } else {
                  batteryAndPace.push(tempArray[i]);
                }
              }
            }
            getSelectedCarsState.set([...batteryAndPace]);
          }
        }
      } else if (
        marshalCars ||
        specialCars ||
        memberCars ||
        bewrageCars ||
        fleetCars ||
        notCommunicatingCars ||
        notInUseCars ||
        paceWarning ||
        paceCritical ||
        batteryWarning ||
        batteryCritical
      ) {
        if (
          updatedCarDataState.get() &&
          updatedCarDataState.get().length !== 0
        ) {
          let allCars = JSON.parse(
            updatedCarDataState.get() && updatedCarDataState.get()
          );
          let tempArray = [];
          let batteryAndPace = [];
          if (allCars && allCars?.length !== 0) {
            for (let i = 0; i < allCars.length; i++) {
              let carTypeHasExplicitFilter =
                allCars[i]?.Car?.CarType === carType?.marshal ||
                allCars[i]?.Car?.CarType === carType?.handicap ||
                allCars[i]?.Car?.CarType === carType?.member ||
                allCars[i]?.Car?.CarType === carType?.bevcart ||
                allCars[i]?.Car?.CarType === carType?.member;
              if (notCommunicatingCars) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notCommunicatingCars &&
                    allCars[i]?.Car?.Connection ===
                      carConnectionType?.notCommunicatingCarEnabled) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                ) {
                  tempArray.push(allCars[i]);
                }
              } else if (
                !notCommunicatingCars &&
                allCars[i]?.Car?.Connection !==
                  carConnectionType?.notCommunicatingCarEnabled
              ) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                  // (fleetCars && !isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                  // (notInUseCars && !isCarInUse(allCars[i]?.Car) && carTypeHasExplicitFilter)
                ) {
                  tempArray.push(allCars[i]);
                }
              }
            }

            if (tempArray && tempArray.length !== 0) {
              for (var i = 0; i < tempArray.length; i++) {
                if (
                  paceWarning ||
                  paceCritical ||
                  batteryWarning ||
                  batteryCritical
                ) {
                  if (
                    (paceWarning &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusWarning) ||
                    (paceCritical &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusCritical) ||
                    (batteryWarning &&
                      tempArray[i]?.Car?.BatteryLevel >
                        batteryStatusAlert?.criticalBatteryLevel &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.warningBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging) ||
                    (batteryCritical &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.criticalBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging)
                  ) {
                    batteryAndPace.push(tempArray[i]);
                  }
                } else {
                  batteryAndPace.push(tempArray[i]);
                }
              }
            }
            getSelectedCarsState.set([...batteryAndPace]);
          }
        }
      } else {
        if (
          updatedCarDataState.get() &&
          updatedCarDataState.get().length !== 0
        ) {
          let allCars = JSON.parse(
            updatedCarDataState.get() && updatedCarDataState.get()
          );
          let tempArray = [];
          let batteryAndPace = [];
          if (allCars && allCars?.length !== 0) {
            for (let i = 0; i < allCars.length; i++) {
              let carTypeHasExplicitFilter =
                allCars[i]?.Car?.CarType === carType?.marshal ||
                allCars[i]?.Car?.CarType === carType?.handicap ||
                allCars[i]?.Car?.CarType === carType?.member ||
                allCars[i]?.Car?.CarType === carType?.bevcart ||
                allCars[i]?.Car?.CarType === carType?.member;
              if (notCommunicatingCars) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notCommunicatingCars &&
                    allCars[i]?.Car?.Connection ===
                      carConnectionType?.notCommunicatingCarEnabled) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                ) {
                  tempArray.push(allCars[i]);
                }
              } else if (
                !notCommunicatingCars &&
                allCars[i]?.Car?.Connection !==
                  carConnectionType?.notCommunicatingCarEnabled
              ) {
                if (
                  (marshalCars &&
                    allCars[i]?.Car?.CarType === carType?.marshal) ||
                  (specialCars &&
                    allCars[i]?.Car?.CarType === carType?.handicap) ||
                  (memberCars &&
                    allCars[i]?.Car?.CarType === carType?.member) ||
                  (bewrageCars &&
                    allCars[i]?.Car?.CarType === carType?.bevcart) ||
                  (fleetCars &&
                    isCarInUse(allCars[i]?.Car) &&
                    !carTypeHasExplicitFilter) ||
                  (notInUseCars && !isCarInUse(allCars[i]?.Car))
                ) {
                  tempArray.push(allCars[i]);
                }
              }
            }

            if (tempArray && tempArray.length !== 0) {
              for (var i = 0; i < tempArray.length; i++) {
                if (
                  paceWarning ||
                  paceCritical ||
                  batteryWarning ||
                  batteryCritical
                ) {
                  if (
                    (paceWarning &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusWarning) ||
                    (paceCritical &&
                      tempArray[i]?.Car?.PaceStatus ===
                        paceStatusAlert?.paceStatusCritical) ||
                    (batteryWarning &&
                      tempArray[i]?.Car?.BatteryLevel >
                        batteryStatusAlert?.criticalBatteryLevel &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.warningBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging) ||
                    (batteryCritical &&
                      tempArray[i]?.Car?.BatteryLevel <=
                        batteryStatusAlert?.criticalBatteryLevel &&
                      !tempArray[i]?.Car?.IsCharging)
                  ) {
                    batteryAndPace.push(tempArray[i]);
                  }
                } else {
                  batteryAndPace.push(tempArray[i]);
                }
              }
            }
            getSelectedCarsState.set([...batteryAndPace]);
          }
        }
      }
    }
  }, [
    marshalCars,
    specialCars,
    memberCars,
    bewrageCars,
    fleetCars,
    notCommunicatingCars,
    notInUseCars,
    paceWarning,
    paceCritical,
    batteryWarning,
    batteryCritical,
    CarLocationBtn,
    isFirstUpdate.get(),
  ]);

  useEffect(() => {
    let localCarData =
      !Array.isArray(updatedCarDataState.get()) &&
      typeof updatedCarDataState.get() === "string" &&
      JSON.parse(updatedCarDataState.get());
    if (
      updatedCarDataState.get() &&
      Array.isArray(localCarData) &&
      localCarData.length !== 0
    ) {
      if (isFirstUpdate.get()) {
        isFirstUpdate.set(false);
      }
    } else {
      getSelectedCarsState.set([]);
    }
  }, [updatedCarDataState.get(), isFirstUpdate.get()]);

  return {
    getSelectedCarsState,
  };
};
